type ButtonLink = {
  anchor?: string;
  target?: string;
  parameters?: string;
  url?: string;
  text?: string;
};

/**
 * Generates a complete URL from a button link object
 * Combines url and parameters if both are present
 *
 * @param buttonLink - Object containing url and parameters
 * @returns Complete URL string with parameters appended if present
 */
const getButtonHref = (buttonLink?: ButtonLink): string => {
  if (!buttonLink) {
    return '';
  }
  if (buttonLink.url && buttonLink.parameters) {
    return `${buttonLink.url}?${buttonLink.parameters}`;
  }
  if (buttonLink.url) {
    return buttonLink.url;
  }
  if (buttonLink.parameters) {
    return `?${buttonLink.parameters}`;
  }
  return '';
};
export default getButtonHref;